const projectId = process.env.NEXT_PUBLIC_PROJECT_ID;

interface ImageLoaderProps {
  src: string;
  width: number;
  quality?: number;
}

export default function supabaseLoader({ src, width, quality }: ImageLoaderProps): string {
  // Allow local images in /public to work
  if (src.startsWith('/')) {
    return `${src}`;
  }
  // If it's already a full URL, just append width and quality parameters
  if (src.startsWith('http')) {
    // Check if URL already has parameters
    const hasParams = src.includes('?');
    const separator = hasParams ? '&' : '?';
    return `${src}${separator}width=${width}&quality=${quality || 80}`;
  }
  // For paths that are not complete URLs (Supabase storage)
  return `https://${projectId}.supabase.co/storage/v1/object/public/${src}?width=${width}&quality=${quality || 80}`;
}
